import script from "./ModelViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelViewer.vue?vue&type=script&setup=true&lang=js"

import "./ModelViewer.vue?vue&type=style&index=0&id=33306b06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33306b06"]])

export default __exports__